import '../../assets/stylesheets/signup/styles.scss'
import { initializeFoundryDropDown } from '@gocanvas/foundry/js/components/exposed-dropdown'
import { getGeoIPCountry } from '../helpers/geoip_helpers.js'
import { getCookie } from '../helpers/helpers.js'

document.addEventListener("DOMContentLoaded", function () {

  const formEl = document.querySelector('.trial-signup-form form')
  const exposedDropdowns = formEl.querySelectorAll(
    '.foundry--exposed-dropdown'
  )
  exposedDropdowns.forEach(initializeFoundryDropDown)

  const fieldsWrap = formEl.querySelector('.signup-form--wrap')
  const countryInput = fieldsWrap.querySelector('input[name="user[country]"]')
  const phoneInput = fieldsWrap.querySelector('input[name="user[phone]"]')
  const unitedStatesString = 'United States of America'

  const nonWorkDomains = [
    'aol',
    'gmail',
    'gmx',
    'hotmail',
    'icloud',
    'mail.com',
    'me.com',
    'outlook',
    'protonmail',
    'yahoo',
    'yandex',
    'zoho',
    'comcast',
    'live',
    'ymail',
    'att',
    'sbcglobal',
  ]

  const marketingParameters = [
    {
      "paramName": "utm_source",
      "cookieName": "ppcSource",
      "defaultValue": "organic",
    },
    {
      "paramName": "utm_medium",
      "cookieName": "ppcMedium",
      "defaultValue": "web",
    },
    {
      "paramName": "utm_campaign",
      "cookieName": "ppcCampaign",
      "defaultValue": "gc-free-trial",
    },
    {
      "paramName": "utm_term",
      "cookieName": "ppcKeyword",
      "defaultValue": "none",
    },
    {
      "paramName": "utm_content",
      "cookieName": "ppcContent",
      "defaultValue": "gc-free-trial-page",
    },
    {
      "paramName": "gclid",
      "cookieName": "ppcGCLID",
      "defaultValue": "",
    }
  ]

  // validations
  const validateWorkEmail = val =>
    !nonWorkDomains.find(domain => val.includes(`@${domain}`))

  const validateEmail = val => {
    const el = document.createElement('input')
    el.type = 'email'
    el.value = val
    const {
      validity: { valid },
    } = el

    return valid
  }

  const validateChars = val => {
    return !val.match(/[^\u0000-\u00ff]/)
  }
  const validatePasswordPolicy = val => {
    if (val.length < 8){
      return false
    } else if (!val.match(/(?=.*[A-Z])/)) {
      return false
    } else if (!val.match(/(?=.*[a-z])/)) {
      return false
    } else if (!val.match(/(?=.*\d)/)) {
      return false
    } else if (!val.match(/(?=.*\W)/)) {
      return false
    } else {
      return true
    }
  }

  const validatePhoneNumber = val => {
    const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
    return !!val.match(phoneRegex)
  }

  const validateCompanyName = string => Boolean(string) && String(string).trim().length > 1
  
  const required = {
    validation: val => !!val.trim(),
  }
  const company_name_length = {
    errorMessage: 'Company Name must be at least 2 characters',
    validation: validateCompanyName 
  }
  const work_email = {
    errorMessage:
      'GoCanvas requires a work email. Please confirm your email address before proceeding',
    validation: validateWorkEmail,
  }
  const is_valid_email = {
    errorMessage: 'Please enter a valid email',
    validation: validateEmail,
  }

  const password_policy = {
    errorMessage: 'Password must have at least 8 characters, and include at least 1 lower case, 1 upper case, 1 number and 1 special character',
    validation: validatePasswordPolicy
  }
  const valid_phone_number = {
    errorMessage: 'Must be a valid phone number',
    validation: validatePhoneNumber,
  }

  const valid_chars = {
    errorMessage: 'Must have valid characters',
    validation: validateChars,
  }

  const formInputValidations = {
    'user[first_name]': [required, valid_chars],
    'user[last_name]': [required, valid_chars],
    'user[industry]': [required],
    'user[email]': [required, work_email, is_valid_email],
    'user[company_name]': [company_name_length],
    'user[company_id]': [required],
    'user[country]': [required],
    'user[phone]': [required, valid_phone_number],
    'user[password]': [required, password_policy],
  }

  const applyError = (inputWrapper, validation) => {
    const inputEl = inputWrapper.querySelector('.input-fields__input')
    const { errorMessage = inputEl.getAttribute('error-msg') } = validation
    const currentError = inputWrapper.querySelector('.field-error--message')
    if (!currentError) {
      const errorEl = document.createElement('div')
      errorEl.classList.add('field-error--wrap')
      errorEl.innerHTML = `
        <i class="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
        <span class="field-error--message">${errorMessage}</span>
      `
      inputWrapper.classList.add('foundry--field-error')
      inputWrapper.appendChild(errorEl)
    } else {
      currentError.innerText = errorMessage
    }
  }

  const removeError = inputWrapper => {
    if (!inputWrapper) { return }
    inputWrapper.classList.remove('foundry--field-error')
    const errorMessage = inputWrapper.querySelector('.field-error--wrap')

    if (errorMessage) {
      errorMessage.remove()
    }
  }

  const updateValidations = ({ removeOnly }) => event => {
    const { target: inputEl } = event
    if (inputEl.matches('input')) {
      const inputWrapper = inputEl.closest('.foundry--input-fields')
      const name = inputEl.getAttribute('name') || inputWrapper.querySelector('[name]').getAttribute('name')
      const inputValidations = formInputValidations[name] || []
      const inputValue = inputEl.value

      const firstInvalid = inputValidations.find(({ validation }) => !validation(inputValue))

      if (!firstInvalid) {
        removeError(inputWrapper)
      }
      else if (!removeOnly) {
        applyError(inputWrapper, firstInvalid)
      }
      if (name === "user[company_name]"){
        if(firstInvalid) {
          inputEl.setCustomValidity(firstInvalid.errorMessage)
        }
        else {
          inputEl.setCustomValidity('');
        }
      }
    }
  }

  const setUserCountry = async () => {
    const countryName = await getGeoIPCountry()
    const country = countryInput.getAttribute('value')
    if (countryName && !country) {
      countryInput.setAttribute('value', countryName)
      countryInput.setAttribute('data-dropdown-label', countryName)
      countryInput.nextElementSibling.setAttribute('value', countryName)
      countryInput.nextElementSibling.setAttribute('data-dropdown-label', countryName)
      countryInput.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  const formatPhone = () => {
    countryInput.addEventListener('input', e => {
      const { target: inputEl } = e
      const inputValue = inputEl.value
      if (inputValue === unitedStatesString) {
        phoneInput.setAttribute('maxlength', 14)
      }
      else {
        phoneInput.setAttribute('maxlength', 15)
      }
    })
    phoneInput.addEventListener('keydown', ({ target, keyCode }) => {
      const { value } = target
      const strippedInputValue = value.replace(/\D/g, '')
      const deleteKey = [8, 46].includes(keyCode)
      const applyFormatting =
        countryInput.value === unitedStatesString &&
        !deleteKey &&
        strippedInputValue.length > 2
      if (applyFormatting) {
        const match = strippedInputValue.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)
        if (match && match.length) {
          target.value = `(${match[1]}) ${match[2]}${match[3] && `-${match[3]}`}`
        }
      }
    })
  }

  const handleMarketingParameters = () => {
    const urlParams = new URLSearchParams(window.location.search)
    for (const { paramName, cookieName, defaultValue } of marketingParameters) {
      const paramValue = urlParams.get(paramName)
      const cookieValue = getCookie(cookieName)
      var input = document.createElement("input")
      input.setAttribute("type", "hidden")
      input.setAttribute("name", paramName)
      input.setAttribute("value", paramValue || cookieValue || defaultValue)
      document.querySelector("form").appendChild(input)
    }
  }

  const formTemplateParameters = () => {
    const formTemplateId = document.getElementById('form_template_id')
    const urlParams = new URLSearchParams(window.location.search)
    formTemplateId.value = urlParams.get('form_template_id')
  }

  formTemplateParameters()
  handleMarketingParameters()
  formatPhone()
  setUserCountry()
  fieldsWrap.addEventListener('focusout', updateValidations({ removeOnly: false }))
  fieldsWrap.addEventListener('input', updateValidations({ removeOnly: true }))

  // Removes the default Rails 'field_with_errors' div and allows proper UI for email field
  const child = document.querySelectorAll('input')

  // disables form on submission (server errors will populate on /users)
  formEl.addEventListener('submit', () => {
    formEl.disabled = true
    const $honeypotInput = formEl.querySelector('input.hp')
    if ($honeypotInput && ($honeypotInput.matches(':-webkit-autofill') || $honeypotInput.matches(':autofill'))){
      $honeypotInput.value = ''
    }
    formEl.querySelectorAll('[type="submit"]').forEach(el => {
      el.classList.add('button--disabled')
      el.disabled = true
    })
  })

  child.forEach(el => {
    if (el.parentElement.classList.contains('field_with_errors')) {
      el.parentElement.replaceWith(...el.parentElement.childNodes)
    }
  })


  //Add foundry error styling to input's if error

  const errorWrapperDiv = (errorMessage, el) => {
    el.parentElement.classList.add('foundry--field-error')
    const errorEl = document.createElement('div')
    errorEl.classList.add('field-error--wrap')
    errorEl.innerHTML = `
          <i class="field-error--icon icon--solid foundry-icon icon--exclamation-triangle"></i>
          <span class="field-error--message">${errorMessage}</span>
        `
    el.parentElement.classList.add('foundry--field-error')
    el.parentElement.appendChild(errorEl)
  }


  function addErrorAttributes() {
    const errorAlert = document.querySelector('.alert--error')
    const phoneError = document.querySelector('#user_phone')
    const emailError = document.querySelector('#user_email')

    if (errorAlert) {
      if (errorAlert.innerText.includes('Phone') && phoneError.type === 'tel') {
        const errorMessage = "Phone number has invalid format based on the selected country"
        errorWrapperDiv(errorMessage, phoneError)
      }
      else if (errorAlert.innerText.includes('Email') && emailError.type === 'text') {
        const errorMessage = "This Email address is already in use"
        errorWrapperDiv(errorMessage, emailError)
      }
    }
  }
  addErrorAttributes()
})
